import React from 'react'
import { Input, Grid, Popup } from 'semantic-ui-react'

const { Row, Column } = Grid

const NumberField = ({
  after,
  before,
  children,
  className,
  disabled,
  error,
  label,
  max,
  min,
  onChange,
  required,
  tooltip,
  validated,
  value,
  step,
}) => (
  <Row className={`field ${className}${required ? ' required' : ''}`}>
    <Column width={4}><span className="field-label">{label}: </span></Column>
    <Column width={8}>
      {before}
      <Input
        disabled={disabled}
        max={max}
        min={min}
        name={name}
        required={required || undefined}
        type="number"
        onChange={(e, event) => onChange(event)}
        value={typeof value !== 'undefined' ? value : ''}
        step={step}
      />
      {after}
      {!!tooltip &&
      <Popup
        trigger={<i className="daicon daicon-Help tooltip" />}
        content={tooltip}
        position="right center"
      />

        }
    </Column>
    <Column width={4}>
      {!!error &&
        <Popup
          trigger={<i className="daicon daicon-Attention error" />}
          content={error}
          position="right center"
        />
      }

      {validated && !error &&
        <i className="daicon daicon-Checkmark success" />
      }

      {children}
    </Column>
  </Row>
  )

NumberField.defaultProps = {
  after: null,
  before: null,
  children: null,
  className: '',
  disabled: false,
  error: '',
  max: null,
  min: null,
  required: false,
  tooltip: '',
  validated: false,
  value: '',
  step: '1',
}

NumberField.propTypes = {
  after: React.PropTypes.any,
  before: React.PropTypes.any,
  children: React.PropTypes.any,
  className: React.PropTypes.string,
  disabled: React.PropTypes.bool,
  error: React.PropTypes.string,
  label: React.PropTypes.string.isRequired,
  max: React.PropTypes.any,
  min: React.PropTypes.any,
  name: React.PropTypes.string.isRequired,
  onChange: React.PropTypes.func.isRequired,
  required: React.PropTypes.bool,
  tooltip: React.PropTypes.any,
  validated: React.PropTypes.bool,
  step: React.PropTypes.string,
  value: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
}

export default NumberField



// WEBPACK FOOTER //
// ./src/browser/components/fields/Number.js